<p-pickList
	[source]="units"
	[target]="selectedUnits"
	filterBy="name"
	sourceHeader="Disponibles"
	targetHeader="Seleccionados"
	>
	<ng-template let-unit pTemplate="item">
		<div class="media-item">
			<div class="media-list-detail">
				<h5 class="mb-2">{{unit.name}}</h5>
				<span class="media-description">{{unit.description}}</span>
			</div>
		</div>
	</ng-template>
</p-pickList>


<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
